import { Component, createRef } from 'react';
import PropTypes from 'prop-types';

class ScrollWatch extends Component {
	wrapper = createRef()

	state = {
		scrollPercent: 0,
		doneScrolling: false,
		scrollPercentX: 0,
		doneScrollingX: false,
		noScrollYet: true,
		noScrollXYet: true,
		scrollY: 0,
		scrollX: 0,
	}

	debouncer = null;

	debounce = event => {
		const DEBOUNCE_RATE = this.props.debounceRate || 100;
		if (this.debouncer) clearTimeout(this.debouncer);
		this.debouncer = setTimeout(this.scrollWatch, DEBOUNCE_RATE, event.target);
	}

	/**
	* Watches for inner scroll of an element
	* and sets state with the % scrolled so far
	*
	* @returns {undefined}
	*/
	scrollWatch = element => {
		const {
			// Vertical Scroll
			scrollHeight,
			scrollTop,
			clientHeight,
			// Horizontal Scroll
			scrollWidth,
			scrollLeft,
			clientWidth,
		} = element;

		const scrollPercent = ( scrollTop + clientHeight ) / scrollHeight;
		const doneScrolling = scrollPercent === 1;
		const noScrollYet = scrollTop === 0;

		const scrollPercentX = ( scrollLeft + clientWidth ) / scrollWidth;
		const doneScrollingX = scrollPercentX === 1;
		const noScrollXYet = scrollLeft === 0;

		const scrollX = scrollLeft;
		const scrollY = scrollTop;

		this.setState({
			scrollPercent,
			doneScrolling,
			scrollPercentX,
			doneScrollingX,
			noScrollYet,
			noScrollXYet,
			scrollX,
			scrollY,
		});
	}

	/**
	* Useful event to trigger clicks if needed
	*
	* @param {distance} Number pixels to move
	* @returns {undefined}
	*/
	scrollTo = distance => e => {
		const { externalRef } = this.props;
		const wrapperToUse = externalRef || this.wrapper;
		const { current } = wrapperToUse;

		const scrolledSoFar = current.scrollLeft;

		current.scroll({
			left: scrolledSoFar + distance,
			behavior: 'smooth',
		});
	}

	componentDidMount () {
		const { externalRef } = this.props;
		const wrapperToUse = externalRef || this.wrapper;
		wrapperToUse.current.addEventListener('scroll', this.debounce);
		this.debounce({ target: wrapperToUse.current });
	}

	componentWillUnmount () {
		const { externalRef } = this.props;
		const wrapperToUse = externalRef || this.wrapper;

		wrapperToUse.current.removeEventListener('scroll', this.debounce);
	}

	render () {
		const { state, wrapper, scrollTo } = this;

		const passedProps = {
			...state,
			wrapperRef: wrapper,
			scrollTo: scrollTo,
		};

		return this.props.children({ ...passedProps });
	}
}

ScrollWatch.propTypes = {
	children: PropTypes.func.isRequired,
	debounceRate: PropTypes.number,
	externalRef: PropTypes.object,
};

export default ScrollWatch;
